/**
 * @file src/components/Header.ts 公共 header 组件
 * @author wangyuzhen01@baidu.com
*/

import {getTrackValue, getUserInfo, getUrlParam, getSealStatus} from '../utils/util';
import {ConfigDetail, Options, UserInfo} from '../interface/common'
import {globalConfig, configDetail as menuConfigDetail, userCenterConfig, funcManageConfig, cloudHost, qifuHost} from '../common/config';

export default class Header {
    // Header 将要挂载到的 dom 节点
    $el: null | HTMLElement = null;

    // 界面类型
    pageType = '';

    // 配置的详细信息
    configDetail: ConfigDetail;

    // 宽屏header元素之间margin值
    marginItemBig: number;

    // 小屏header元素之间margin值
    marginItemMini: number;

    // 超小屏header元素之间margin值
    marginItemSmaller: number;

    // 宽屏header两侧margin值
    paddingContainerBig: number;

    // 小屏header两侧margin值
    paddingContainerMini: number;

    constructor(options: Options) {
        const {el, pageType, configDetail} = options;
        this.$el = el;
        this.marginItemBig = 14;
        this.marginItemMini = 12;
        this.marginItemSmaller = 10;
        this.paddingContainerBig = 66;
        this.paddingContainerMini = 30;

        this.pageType = pageType;
        this.configDetail = configDetail
            || globalConfig.getConfigDetailByPageType(this.pageType)
            || menuConfigDetail;
        this.creareHeader();
    }

    // 生成跟踪track
    createTrack(): string {
        let trackData = getTrackValue() || `${this.pageType}_QifuHeader`;
        trackData = trackData.toLowerCase();
        return `trace=${trackData}&pageResource=${trackData}`;
    }

    createFuncMannage(): string {
        return funcManageConfig
            ?.map(item => `<a href="${item.link}" target="_blank">${item.label}</a>`)
            ?.join('');
    }

    // 登录（未登录）状态显示的内容
    async loginStatusSwitch() {
        // 获取用户状态信息
        const userContainer = document.querySelector('.user-container');
        const res: UserInfo = await getUserInfo();
        const login = `
            <div class="username-container">
                <div class="username">
                    <a>${res?.displayName}</a>
                </div>
                <div class="user-list-box">

                    ${
                        userCenterConfig.funcList
                            .map(
                                item =>  '<a class="user-item" target="'
                                        + (item.openNew ? "_blank" : "_self") +'" href="'
                                        + item.link +'">'
                                        + item.label + '</a>'
                            )
                            .join('')
                    }
                </div>
            </div>
        `;
        if (userContainer && res.hasLogin) {
            /* bca-disable */
            userContainer.innerHTML = login;
            this.realStatus();
        }

    }
    // 显示实名用户提示
    async realStatus() {

        const realStatus: any = await getSealStatus(`${location.origin}/api/account/real_name_info`);
        const statusObj = JSON.parse(realStatus);

        if (statusObj && statusObj.result && statusObj.result.primePassFlag) {

            const userListBox: any = document.querySelector('.user-list-box');
            const aDom = document.createElement('a');
            aDom.className = 'user-real-name';
            aDom.innerText = '实名认证用户';

            userListBox.insertBefore(aDom, userListBox.children[0]);
        }
    }
    // 创建顶部服务中心
    async createTopServiceCentre() {
        let serviceCentre = '';

        const createNav = await this.createNav();
        serviceCentre = `
            <div class="qifu-header-service-container">
                <div class="header-service-left">
                    <a class="cloud-logo" href="${cloudHost}" target="_blank">
                        <img src="https://qifu-public.cdn.bcebos.com/portal/header/qifu-logo.png" target="_blank">
                    </a>
                    <a class="qifu-logo" href="${qifuHost}" target="_blank"></a>
                </div>
                <div class="qifu-header-nav">${createNav}</div>
                <div class="header-service-right">
                    ${this.createFuncMannage()}
                    <div class="header-service-slipt-line"></div>
                    <div class="user-container">
                        <a class="login" id="loginContainer">登录</a>
                        <a class="register" id="registerContainer">注册</a>
                    </div>
                </div>
            </div>
        `;
        return serviceCentre
    }

    //创建导航
    createNav(): string {
        const {menuItems} = this.configDetail;
        const trackQuery = this.createTrack();
        // 导航栏代码片段
        let navHtml = '';
        // 菜单列表
        let menuItemHtml = '';
        menuItems.forEach((item, i) => {
            // 子类列表
            let childrenItemHtml = '';
            // 是否有子列表
            const isHaveChild = Boolean(item.childrenItems && item.childrenItems.length);
            // 拼接子类列表

            if (isHaveChild) {
                childrenItemHtml = `
                    <div class="nav-item-container-children">
                        ${item?.childrenItems?.map(child => {
                            const href = `${child.targetUrl || ''}${child.pageType === 'BCD_PORTAL01' ? '&' : '?'}${trackQuery}&select=${i}`;
                            const tagHtml = child.tagImg ? `<span class="children-item-tag" style="background-image: url(${child.tagImg})"></span>` : '';
                            return `<a class="children-item" href="${href}" target="_blank">${child.label}${tagHtml}</a>`;
                        }
                        ).join('')}
                    </div>
                `;
            }

            menuItemHtml += `
                <div class="nav-item-container">
                    <div class="nav-item-container-name">
                        <a class="nav-item-text ${isHaveChild ? '' : 'nav-item-text-cursor'}" target="_blank" href="${item.targetUrl || ''}?${trackQuery}">${item.label}</a>
                    </div>
                    ${childrenItemHtml}
                </div>
            `;
        });
        navHtml = `<div class="qifu-header-nav-container">${menuItemHtml}<div class="nav-active-line"></div></div>`;

        return navHtml;
    }

    // 创建Header
    async creareHeader() {
        if (!this.$el) {
            return;
        }
        const createTopServiceCentreHtml = await this.createTopServiceCentre();
        const template = `
            <header class="qifu-header-sdk-container">
                <div class="qifu-header-content">
                    ${createTopServiceCentreHtml}
                    <div class="header-over-next-line"></div>
                </div>
            </header>
        `;
        /* bca-disable */
        this.$el.innerHTML = template;
        setTimeout(() => {
            this.autoAdaptate();
            this.autoSelectedStatus();
            this.loginStatusSwitch();
            this.navBindMouseEvent();
        })

        window.onresize = () => {
            this.autoAdaptate();
            this.navBindMouseEvent();
        }
    }

    autoSelectedStatus() {
        // 导航容器
        const navContainer: any = document.querySelector('.qifu-header-nav-container');
        // 导航数组
        const navContaineritems = navContainer.children;
        const selected = getUrlParam('select');
        if (selected) {
            const itemClass = navContaineritems[selected].className.split(' ');
            itemClass.push('nav-item-container-hover');

            navContaineritems[selected].className = itemClass.join(' ');
        }
    }

    autoAdaptate() {
        // 头部容器
        const headerNavContainer: any = document.querySelector('.qifu-header-nav');
        // 导航容器
        const navContainer: any = document.querySelector('.qifu-header-nav-container');
        // 小屏幕导航容器
        const navNextLineContainer: any = document.querySelector('.header-over-next-line');

        // 判断自适应
        if (window.innerWidth <= 1280) {
            navNextLineContainer.appendChild(navContainer);
        } else if (!headerNavContainer.children.length) {
            // 缩小宽度后再拉长宽度，导航位置返回
            headerNavContainer.appendChild(navContainer);
        }
    }

    /**
     * 导航绑定鼠标事件
     */
    navBindMouseEvent() {
        // 导航数组
        const navContainerItems: any = document.querySelectorAll('.qifu-header-nav-container .nav-item-container');
        // 活跃导航下划线
        const navActiveLine: any = document.querySelector('.qifu-header-nav-container .nav-active-line');
        // 自适应导航项间距
        const navItemPadding = window.innerWidth > 1280 && window.innerWidth < 1430 ? 6 : 10;
        
        Array.from(navContainerItems).forEach((item: any) => {
            item.addEventListener('mouseenter', () => {
                navActiveLine.style.width = `${item.offsetWidth - 2 * navItemPadding}px`;
                navActiveLine.style.left = `${item.offsetLeft + navItemPadding}px`;
            })
            item.addEventListener('mouseleave', () => {
                navActiveLine.style.width = '0px';
            })
        });
    }
}

